import { createSlice } from "@reduxjs/toolkit";

const initialState ={
    apercuShow : false,
    ajoutsuccess : false,
    modifsuccess : false,
    showmodal : false,
    list :[],
    current : [],
    listVendeurs : [],
    listPreVendeurs : [],
    listCamions : [],
}

const Chargements = createSlice({
    name : 'ChargementsData',
    initialState,
    reducers :{
        ajoutsuccess:(state,action) =>{
            state.ajoutsuccess=action.payload
        },
        modifsuccess:(state,action) =>{
            state.modifsuccess=action.payload
        },
        idchargement:(state,action) =>{
            state.current=action.payload
        },
        showapercu:(state,action) =>{
            state.apercuShow=action.payload
        },
        showmodal:(state,action) =>{
            state.showmodal=action.payload
        },
        getvendeurs:(state,action) =>{
            state.listVendeurs=action.payload
        },
        getprevendeurs:(state,action) =>{
            state.listPreVendeurs=action.payload
        },

        getcamions:(state,action) =>{
            state.listCamions=action.payload
        },
        addOne:(state,action) =>{
            state.list.push(action.payload)
        },
        getList:(state,action) =>{
            state.list=action.payload
        },
          remove: (state, action) => {    
            const id = action.payload;
            state.list=state.list.filter(element => element._id !== id);
  }
    }
})

export const {ajoutsuccess,ajout,addOne,idchargement,modifsuccess,showapercu,showmodal,getvendeurs,getprevendeurs,getcamions,getList,remove} = Chargements.actions
export default Chargements.reducer;